import React, { Component } from 'react';
import { Button, FormGroup, FormControl, Popover, OverlayTrigger } from 'react-bootstrap'
import { translate } from "react-translate"

@translate("Form")
export default class Form extends Component {

	constructor (props) {
    super(props)

    let name = props.name
    let phone = props.phone
    let email = props.email
    let query = props.query

    if (props.property){
      let height = (props.property.height === '0') ? '' : props.property.height
      var dir = (props.property.address).toLowerCase()
      var zone = (' ubicada en ' + props.property.neighborhood.name + ', ' +  props.property.zone.name + '.')
    }

    let defaultQuery = (props.textareaDefault ? '¡Hola! Estoy interesado/a en la propiedad ' + dir + zone  : query)
    this.query = defaultQuery
    this.state = {
      name: name,
      phone: phone,
      email: email,
      query: defaultQuery ? defaultQuery : '' ,
      validateName : '',
      validatePhone : '',
      validateEmail : '',
    }
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeQuery = this.handleChangeQuery.bind(this);
  }

  handleChangeName(event) {
    let state = ''
    this.setState({name: event.target.value});
    state = this._validate('name')
    this.setState({validateName: state})
  }
  handleChangePhone(event) {
    let state = ''
    this.setState({phone: event.target.value});
    state = this._validate('phone')
    this.setState({validatePhone: state})
  }
  handleChangeEmail(event) {
    let state = ''
    this.setState({email: event.target.value});
    state = this._validate('email')
    this.setState({validateEmail: state})
  }
  handleChangeQuery(event) {
    this.setState({query: event.target.value});
  }

  _handleSubmit(e, additionals){
    e.preventDefault();
    if (this.state.validateName === 'success') {
      if (this.state.validatePhone === 'success') {
        if (this.state.validateEmail  === 'success') {
          let form = {
            name: this.state.name,
            phone: this.state.phone,
            email: this.state.email,
            query: this.state.query,
          }
          this.props.onSubmitContactForm(form, additionals)
        }
      }
    }
  }

  _handleReset(e){
    e.preventDefault()
    this.props.resetContactForm()
    this._resetState()
  }

  _validate(value) {
    let patt = ''
    switch(value) {
      case 'name':
        patt = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/
        if ((this.state.name !== '') && (patt.test(this.state.name))) {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
      case 'phone':
        patt = /^[0-9]+$/
        if ((this.state.phone !== '') && (patt.test(this.state.phone))) {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
      case 'email':
        patt = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/
        if ((this.state.email !== '') && (patt.test(this.state.email))) {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
    }
  }

  _resetState(){
    this.setState({name: ''});
    this.setState({phone: ''});
    this.setState({email: ''});
    this.setState({query: this.query ? this.query : ''});
  }

  componentWillMount() {
    if (this.props.send){
      this.props.resetContactForm()
      this.setState({name: ''});
      this.setState({phone: ''});
      this.setState({email: ''});
      this.setState({query: ''});
    }
  }

  render(){

  	const { onSubmitContactForm, resetContactForm, textareaDefault, send, property, director, broker, t, originPath, originPathName, originOffice, originOfficeName, subsidiary } = this.props

  	let value = this.state
    let additionals = {
      property_code: (property) ? property.property_code : 0,
      property_title: (property) ? (property.title ? property.title : (property.property_code && property.category_type_name ? (property.category_type_name + ' (' + property.property_code + ') ' + property.address) : '' )) : '',
      property_value: (property) ? ((property.category_type_id === 9 || !property.web_price) ? undefined : (property.operation_type.id === 1 ? property.sale_amount : property.rental_amount)) : '',
      property_currency: (property) ? ((property.category_type_id === 9 || !property.web_price) ? undefined : (property.operation_type.id === 1 ? (property.sale_currency.id === 5 ? 'USD' : 'ARS') : (property.rental_currency.id === 5 ? 'USD' : 'ARS'))) : '',
      operation_info: (property) ? ( (property.operation_type && property.operation_type.name ? (property.operation_type.name + ' > ') : '') + (property.property_type && property.property_type.name ? (property.property_type.name) : '') ) : '',
      property_type: property && property.property_type && property.property_type.name ? (property.property_type.name) : '',
      operation_type: property && property.operation_type && property.operation_type.name ? property.operation_type.name : '',
			category: (originPathName && originPathName !== "/") ? (originPathName + (originOfficeName ? ' > ' + originOfficeName[0].toUpperCase() + originOfficeName.substring(1) : '')) : (property && property.category_type_name ? (property.category_type_name[0].toUpperCase() + property.category_type_name.substring(1) + (property && property.subsidiary_type_name ? (' > ' + property.subsidiary_type_name[0].toUpperCase() + property.subsidiary_type_name.substring(1)) : '' )) : ''),
			director: ((originPath === "") && (broker)) ? broker.name : '',
      broker: ((broker) && (originPath !== "")) ? broker.name : '',
      contact_to: (broker) ? (broker.name + ', ' + broker.position) : '',
      sector: originPath ? originPathName : '',
      subsidiary: originOffice ? originOffice : (subsidiary ? subsidiary : ''),
      officeName: originOfficeName,
      pathName: originPathName,
      branch: property&& property.branch,
    }

    if (send) {
      return(
        <div className="thanks-box">
          <div className="form-title">{t("Texto_Principal_Exito")}</div>
          <div className="form-subtitle">{t("Texto_Secundario_Exito")}</div>
          <Button type="button" className="btn-form-reset" onClick={(e) => this._handleReset(e)}>
            {t("Realizar_Otra_Consulta")}
          </Button>
        </div>
      )
    }
    else{
      return(
        <div className="left-content">
          <form>
            <FormGroup validationState={this.state.validateName}>
              <FormControl type="text" placeholder={t("Nombre")} value={this.state.name} onChange={this.handleChangeName} />
            </FormGroup>
            <FormGroup validationState={this.state.validatePhone}>
              <FormControl type="text" placeholder={t("Telefono")} value={this.state.phone} onChange={this.handleChangePhone}/>
            </FormGroup>
            <FormGroup validationState={this.state.validateEmail}>
              <FormControl type="text" placeholder={t("Email")} value={this.state.email} onChange={this.handleChangeEmail}/>
            </FormGroup>
            <FormGroup validationState="">
              <FormControl placeholder={t("Consulta")} componentClass="textarea" value={this.state.query} onChange={this.handleChangeQuery}/>
            </FormGroup>
            <Button type="button" className="btn-form" onClick={(e) => this._handleSubmit(e, additionals)}>
              {t("Enviar_consulta")}
            </Button>
          </form>
        </div>
      )
    }
	}
}



// WEBPACK FOOTER //
// ./src/features/commons/ContactForm/form.js